import { useEffect, useState } from 'react';
import useCollapsible from './useCollapsible';

const getResourceInfo = (resources) =>
  resources.map(({ id, displayName, alreadyAssigned }) => ({
    id,
    value: displayName,
    alreadyAssigned,
  }));

const useResourcesInfo = (resources) => {
  const [resourcesInfo, setResourcesInfo] = useState(
    getResourceInfo(resources),
  );
  const [isShowMoreAlert, setIsShowMoreAlert] = useState(false);
  const showMoreNumber = resourcesInfo.length - 3;
  const { isCollapsed, button } = useCollapsible(
    showMoreNumber,
    isShowMoreAlert,
  );

  useEffect(() => {
    const newResourcesInfo = getResourceInfo(resources);
    setResourcesInfo(newResourcesInfo);

    const newIsShowMoreAlert = !!newResourcesInfo
      .slice(3)
      .find((r) => r.alreadyAssigned);
    setIsShowMoreAlert(newIsShowMoreAlert);
  }, [resources]);

  return {
    resourcesInfo: isCollapsed ? resourcesInfo.slice(0, 3) : resourcesInfo,
    showAll: !isCollapsed,
    button,
  };
};

export default useResourcesInfo;
